export const experienceData = [
  {
    id: 1,
    company: "Xebo.ai ",
    jobtitle: "Software Engineer",
    startYear: "May 2024",
    dis: "",
    endYear: "Present",
  },
  {
    id: 1,
    company: "AICAN Private Limited ",
    jobtitle: "Web Developer Intern",
    startYear: "Sept 2023",
    dis: "",
    endYear: "March 2024",
  },
  {
    id: 2,
    company: "Null Organization",
    jobtitle: "Frontend eb Developer Intern",
    startYear: "May 2023",
    dis: "",
    endYear: " Jully 2023",
  },
];
